import React, { useState } from "react";
// import classnames from 'classnames';
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import windowSize from "react-window-size";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const PartnerTopMenu = windowSize(
  withRouter(props => {
    console.log('props.location.pathname.split("/")[1]', props.location.pathname.split("/")[1])
    const [settlementId, setCount] = useState(
      props &&
        props.location &&
        props.location.pathname &&
        props.location.pathname.split("/")[1] ? props.location.pathname.split("/")[1] : "affiliate"
    );
    // // const [redirctTo, setRedirctTo] = useState(false); // your state value to manipulate
    // useEffect(() => {

    //     // const { history } = this.props;
    //     // history.push(settlementId)
    //     // Update the document title using the browser API
    //     console.log('sssssssssss', props, props && props.location && props.location.pathname && props.location.pathname.split("/")[1])
    //     // return <Redirect to={settlementId} />
    // });
    const userObject = JSON.parse(localStorage.getItem("userObject"));
    return props.windowWidth > 600 ? (
      <div >
      
        {userObject && userObject.userDto.parentAffiliateUser === "Yes" ?    //Logging out
        
        <div className="p-menu-tab-outer">
            <Link to= "/parent-affiliate" 
          onClick={() => {
            setCount("affiliate")
          }}
        >
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                props.location.pathname === "/parent-affiliate"
                ? "active"
                : ""
              }`}
          >
            Dashboard
          </div>
        </Link>
          <Link to="/settlementAffiliate" onClick={() => {
          setCount("settlementAffiliate")
        }}>
          <div
            className={`p-menu-tab ${
              (props &&
                props.location &&
                
                props.location.pathname.split("/")[1] === "settlementAffiliate"
                ? "active"
                : ""
    )}`}
          >
            Settlements
          </div>
        </Link>
        {userObject && userObject.userDto.parentAffiliateUser === "Yes" ?     //Logging out
        <Link to="/groupsAffiliate" onClick={() => {
          setCount("groupsAffiliate")
        }}>
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                (props.location.pathname.split("/")[1] === "groupsAffiliate" ||
                  props.location.pathname.split("/")[1] === "groupDetail")
                ? "active"
                : ""
              }`}
          >
            Groups
          </div>
        </Link>
        :
        <Link to="/usersAffiliate" onClick={() => {
          setCount("usersAffiliate")
        }}>
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                (props.location.pathname === "/usersAffiliate" ||
                  props.location.pathname.split("/")[1] === "userDetail")
                ? "active"
                : ""
              }`}
          >
            Users
          </div>
        </Link>
        }


        <Link to="/resources" onClick={() => {
          setCount("resources")
        }}>
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                props.location.pathname === "/resources"
                ? "active"
                : ""
              }`}
          >
            Resources
          </div>
        </Link>
        
        {/* <Link to="/profile" onClick={() => {
          setCount("profile")
        }}>
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                props.location.pathname === "/profile"
                ? "active"
                : ""
              }`}
          >
           My Profile
          </div>
        </Link> */}
        </div>
        : 
        <div className="p-menu-tab-outer">
            <Link to= "/affiliate"
          onClick={() => {
            setCount("affiliate")
          }}
        >
          <div
            className={`p-menu-tab ${
              props &&
                props.location &&
                props.location.pathname === "/affiliate"
                ? "active"
                : ""
              }`}
          >
            Overview
          </div>
        </Link>
        <Link to="/settlementAffiliate" onClick={() => {
        setCount("settlementAffiliate")
      }}>
        <div
          className={`p-menu-tab ${
            (props &&
              props.location &&
              
              props.location.pathname.split("/")[1] === "settlementAffiliate"
              ? "active"
              : ""
  )}`}
        >
          Settlements
        </div>
      </Link>
      {userObject && userObject.userDto.parentAffiliateUser === "Yes" ?   //Logging out
      <Link to="/groupsAffiliate" onClick={() => {
        setCount("groupsAffiliate")
      }}>
        <div
          className={`p-menu-tab ${
            props &&
              props.location &&
              (props.location.pathname === "/groupsAffiliate" ||
                props.location.pathname.split("/")[1] === "groupDetail")
              ? "active"
              : ""
            }`}
        >
          Groups
        </div>
      </Link>
      :
      <Link to="/usersAffiliate" onClick={() => {
        setCount("usersAffiliate")
      }}>
        <div
          className={`p-menu-tab ${
            props &&
              props.location &&
              (props.location.pathname === "/usersAffiliate" ||
                props.location.pathname.split("/")[1] === "userDetail")
              ? "active"
              : ""
            }`}
        >
          Users
        </div>
      </Link>
      }


      <Link to="/resources" onClick={() => {
        setCount("resources")
      }}>
        <div
          className={`p-menu-tab ${
            props &&
              props.location &&
              props.location.pathname === "/resources"
              ? "active"
              : ""
            }`}
        >
          Resources
        </div>
      </Link>
      
      <Link to="/profile" onClick={() => {
        setCount("profile")
      }}>
        <div
          className={`p-menu-tab ${
            props &&
              props.location &&
              props.location.pathname === "/profile"
              ? "active"
              : ""
            }`}
        >
         My Profile
        </div>
      </Link>
      </div>

      }
        
      </div>
    ) : (
        <div className="p-menu-tab-outer">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            className="p-ro-select"
            name="settlementId"
            value={settlementId}
            onChange={event => {
              setCount(event.target.value);
              props.history.push(`/${event.target.value}`);
            }}
          >
            <MenuItem className="p-ro-select-value"
              value="affiliate">OVERVIEW</MenuItem>
            <MenuItem className="p-ro-select-value" value="settlementAffiliate">SETTLEMENTS</MenuItem>
            <MenuItem className="p-ro-select-value" value="usersAffiliate">USERS</MenuItem>
            <MenuItem className="p-ro-select-value" value="resources">RESOURCES</MenuItem>
            <MenuItem className="p-ro-select-value" value="profile"> MY PROFILE</MenuItem>
            

          </Select>
        </div>
      );
  })
);

PartnerTopMenu.propTypes = {
  userInfo: PropTypes.any
};

export default PartnerTopMenu;
